<div class="columns-dialog">
  <mat-dialog-content>
    <div class="columns-dialog__selections-containter">
      <div class="columns-dialog__select-all">
        <mat-checkbox
          color="primary"
          [checked]="allCompleted()"
          [indeterminate]="someComplete()"
          (change)="setAll($event.checked)">
          All Columns
        </mat-checkbox>
      </div>
      @for (column of columnsForSelection; track column) {
        <div>
          <mat-checkbox color="primary" [(ngModel)]="column.selected" [disabled]="!!column.checkboxDisabled">
            {{ column.title }}
          </mat-checkbox>
        </div>
      }
    </div>
  </mat-dialog-content>
  <mat-divider />
  <mat-dialog-actions align="end" class="footer">
    <div class="columns-dialog__footer">
      <button mat-button (click)='reset()'>Reset all</button>
      <button mat-stroked-button (click)='close()'>Cancel</button>
      <button mat-stroked-button color="primary" (click)='apply()'>Apply</button>
    </div>
  </mat-dialog-actions>
</div>
